import React from 'react'
import { Hit, InfiniteHitsProvided } from 'react-instantsearch-core'
import { connectInfiniteHits } from 'react-instantsearch-dom'

import { LoadingIndicator } from 'Components'
import { Recipe } from 'Models'
import { useInfiniteScrollSentinel } from 'Utils/helpers/useInfiniteScrollSentinel'

type RecipeHitRecord = Hit<Recipe>

type InfiniteRecipeHitsProps = InfiniteHitsProvided<RecipeHitRecord> & {
  hitComponent: React.FC<{ hit: Recipe }>
}

export const InfiniteRecipeHits = connectInfiniteHits(
  ({ hits, hasMore, refineNext, hitComponent: HitComponent }: InfiniteRecipeHitsProps) => {
    const { sentinelRef, isLoadingMore } = useInfiniteScrollSentinel({
      hasMore,
      onLoadMore: refineNext,
      resetKey: hits.length
    })

    return (
      <div className="ais-InfiniteHits">
        <ul className="ais-InfiniteHits-list">
          {hits.map((hit) => (
            <li key={hit.objectID} className="ais-InfiniteHits-item">
              <HitComponent hit={hit} />
            </li>
          ))}
        </ul>

        {hasMore && <div ref={sentinelRef} aria-hidden="true" />}

        {isLoadingMore && (
          <div className="mt-3 mb-3">
            <LoadingIndicator />
          </div>
        )}
      </div>
    )
  }
) as React.ComponentType<{ hitComponent: React.FC<{ hit: Recipe }> }>
